import * as React from 'react';
import {FlatList, StyleSheet, TouchableOpacity} from 'react-native';
import { View, Text } from 'react-native';
import {useNavigation} from "@react-navigation/native";



export default function Settings() {
    const navigation = useNavigation();

    return (
    <View style={styles.container}>
        <Text>Settings Page</Text>

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  boxContainer: {
      backgroundColor: '#2f95dc',
      width: 200,
      height: 100,
      margin: 25,
      borderRadius: 10,
      alignItems: 'center',
      justifyContent: 'center',
  },
  text: {
      fontSize: 16,
      fontWeight: '500',
      color: 'white',
  },
});
